import { useAuth } from '@/context/AuthContext';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const REGION_COUNTRY = {
  uk: 'United Kingdom',
  nigeria: 'Nigeria',
  ghana: 'Ghana',
  international: '',
};

export default function DemoConversionBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  if (!user?.is_demo || dismissed) return null;

  const handleRegister = () => {
    const params = new URLSearchParams();
    if (user.name && user.name !== 'Demo User') params.set('name', user.name);
    if (user.email) params.set('email', user.email);
    if (user.demo_phone) params.set('phone', user.demo_phone);
    if (user.demo_city) params.set('city', user.demo_city);
    const country = user.demo_country || REGION_COUNTRY[user.region] || '';
    if (country) params.set('country', country);
    if (user.region) params.set('region', user.region);

    const qs = params.toString();
    navigate(`/register${qs ? `?${qs}` : ''}`);
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9998] bg-gradient-to-r from-[#2B1F27] via-[#2A2A2A] to-[#2B1F27] border-t border-[#B99A65]/30 px-4 py-3 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]"
      data-testid="demo-conversion-banner"
    >
      <div className="max-w-5xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-2 h-2 rounded-full bg-[#B99A65] animate-pulse shrink-0" />
          <p className="text-white/80 text-sm truncate">
            <span className="text-[#B99A65] font-semibold">Like what you see?</span>
            <span className="hidden sm:inline"> Register your salon to get full access to the platform.</span>
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button
            onClick={handleRegister}
            className="bg-[#B99A65] hover:bg-[#B08C3E] text-white text-xs uppercase tracking-widest h-9 px-5 rounded-none"
            data-testid="demo-register-now-btn"
          >
            Register Now <ArrowRight className="w-3.5 h-3.5 ml-1.5" />
          </Button>
          <button
            onClick={() => setDismissed(true)}
            className="p-1.5 text-white/40 hover:text-white/70 transition-colors"
            data-testid="demo-conversion-dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
